import React from 'react';
import { HStack, Skeleton } from '@chakra-ui/react';

import SunshineCard from '../../../../../components/_core/SunshineCard';

const LoadingAggregationItem = () => (
  <SunshineCard>
    <HStack spacing="space-16">
      <Skeleton
        borderRadius="radius-8"
        endColor="grey.300"
        height="40px"
        startColor="grey.100"
        width="40px"
      />

      <SunshineCard.Content>
        <Skeleton
          borderRadius="radius-4"
          endColor="grey.300"
          height="6px"
          startColor="grey.100"
          width="199px"
        />

        <Skeleton
          borderRadius="radius-4"
          endColor="grey.300"
          height="6px"
          marginTop="space-12"
          startColor="grey.100"
          width="170px"
        />
      </SunshineCard.Content>
    </HStack>
  </SunshineCard>
);

const LoadingFilterGroup = () => {
  return (
    <SunshineCard.Group>
      <LoadingAggregationItem />
      <LoadingAggregationItem />
      <LoadingAggregationItem />
    </SunshineCard.Group>
  );
};

export default LoadingFilterGroup;
